<template lang="pug">
  iframe.iframe(v-if="metaBase && metaBase.ativa", :src="metaBase.url")
</template>
<script>
import axios from '@/utils/api'
export default {
  data () {
    return {
      metaBase: {
        url: '',
        ativa: false
      }
    }
  },

  async created () {
    const data = await axios({
      method: 'get',
      url: 'api/metabase/salaSituacao'
    })

    this.metaBase.url = data.url
    this.metaBase.ativa = data.ativa
  }

}

</script>

<style lang="scss" scoped>
.iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/screens/sala_situacao/Home.vue